// Названия секций каталожных баз хранятся в данных с эмодзи-префиксами.
// До чистки данных на бэке/в PG убираем эмодзи при рендере.
export const stripEmoji = (str) =>
  (str || '')
    .replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{2190}-\u{21FF}\u{2300}-\u{23FF}\u{25A0}-\u{25FF}\u{FE0F}\u{200D}\u{2139}]/gu, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
